import { Box, Typography } from '@mui/material';
import { Dispatch, SetStateAction, memo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import KitModal from '../UI/KitModal';

export type LinesReference = {
  lines: string;
  pageContent: string;
};

export type ReferencesHeader = {
  pageContent: string;
  dimensions: Array<string>;
};

interface LinesReferenceModalProps {
  openLinesReferenceModal: boolean;
  setLinesReferenceModal: Dispatch<SetStateAction<boolean>>;
  linesReferences: LinesReference[] | null;
  referencesHeader: ReferencesHeader | null;
}

const LinesReferenceModal = ({
  openLinesReferenceModal,
  setLinesReferenceModal,
  linesReferences,
  referencesHeader,
}: LinesReferenceModalProps) => {
  return (
    <KitModal
      show={openLinesReferenceModal}
      fullWidth
      onHide={() => setLinesReferenceModal(false)}
    >
      <Box>
        {referencesHeader?.pageContent && (
          <Box sx={{ mb: 2 }}>
            <ReactMarkdown rehypePlugins={[rehypeRaw, rehypeSanitize]}>
              {referencesHeader.pageContent}
            </ReactMarkdown>
          </Box>
        )}
        {linesReferences?.map((item, i) => (
          <Box key={`${item.lines}-${i}`}>
            <Typography variant='h3'>{item.lines}</Typography>
            <ReactMarkdown rehypePlugins={[rehypeRaw, rehypeSanitize]}>
              {item.pageContent}
            </ReactMarkdown>
          </Box>
        ))}
      </Box>
    </KitModal>
  );
};

export default memo(LinesReferenceModal);
